/**
 * @generated SignedSource<<a3d0d13138eca4872847b6a4d484945b>>
 * @relayHash df6009249d7d3d35364a5e60ca174780
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/554.0.0-2026-04-08T14:49:45.172Z/ProductImageCarouselRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarouselRefetchQuery$variables = {
  fetchPhotos?: boolean | null;
  itemId: string;
};
export type ProductImageCarouselRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarouselRefetch_viewer">;
  };
};
export type ProductImageCarouselRefetchQuery = {
  response: ProductImageCarouselRefetchQuery$data;
  variables: ProductImageCarouselRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "fetchPhotos"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductImageCarouselRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchPhotos",
                "variableName": "fetchPhotos"
              },
              (v1/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProductImageCarouselRefetch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductImageCarouselRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "fetchPhotos",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "ItemPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "masterOrZoomPath",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "smallPath",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhotoVersion",
                    "kind": "LinkedField",
                    "name": "versions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webPath",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/554.0.0-2026-04-08T14:49:45.172Z/ProductImageCarouselRefetchQuery",
    "metadata": {},
    "name": "ProductImageCarouselRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da41128a7beb292e1c821e705541b6e5";

export default node;
